import React, { useState } from "react";
import { Input } from "./input";
import { Eye, EyeOff } from "lucide-react";

/**
 * Password input with toggle visibility (eye icon).
 * Forwards all props to the underlying Input (data-testid, value, onChange, etc.).
 */
export function PasswordInput({ className = "", "data-testid": testid, ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input
        {...props}
        type={show ? "text" : "password"}
        className={`pr-10 ${className}`}
        data-testid={testid}
      />
      <button
        type="button"
        onClick={() => setShow(s => !s)}
        tabIndex={-1}
        aria-label={show ? "Masquer le mot de passe" : "Afficher le mot de passe"}
        data-testid={testid ? `${testid}-toggle` : "password-toggle"}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-muted-foreground hover:text-foreground rounded transition-colors"
      >
        {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
      </button>
    </div>
  );
}
